import { createSelector } from "reselect";

import type { NlisHoldingDeviceRow } from "constants/columnDefinitions/nlisHoldings";

import { EMPTY_ARRAY } from "lib";
import { getNlisHoldings } from "./root.state";

export const selectNlisHoldingDeviceRows = createSelector(
  [getNlisHoldings],
  (holdingsById): NlisHoldingDeviceRow[] => {
    const holdings = Object.values(holdingsById);

    if (holdings.length === 0) {
      return EMPTY_ARRAY;
    }

    return holdings.flatMap(holding =>
      holding.devices.map(device => ({
        device,
        holding,
      })),
    );
  },
);
